import request from '@/utils/request'

// 查询
export function fetchList (data) {
  return request.post('/api/TDutyAppPrintLog/findByPage', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/api/TDutyAppPrintLog/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/tbBaseOutboundRecords/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/api/TDutyAppPrintLog/removeById/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.post('/api/TDutyAppPrintLog/removeBatch', [...ids.split(',')])
}

// excel客户数据模板导出
export function exportExcelTemApi(data) {
  return request.post('/tb-base-outbound-records/exportExcel',data, {
      responseType: 'blob',
  })
}

// 清空全部数据
export function clearAllApi() {
  return request.get('/api/TDutyAppPrintLog/clearAll')
}